angular.module('randomization')
    .component('randomizationMain', {
        templateUrl: 'modules/randomization/components/main/content.html',
        controller: 'RandomizationController',
    });
